import { typeUtils } from '@festina-life/core'

import type { CreateGlMapHideDraftInput } from './types'

export const validateKey =
  typeUtils.createValidator<CreateGlMapHideDraftInput>()
